import { createAction } from '@reduxjs/toolkit';

export const PROCESS_CALL_PARK_ACTION_TYPE = 'saga/processCallPark';
export const processCallParkAction = createAction(PROCESS_CALL_PARK_ACTION_TYPE);
